import { render, staticRenderFns } from "./ModalVideo.vue?vue&type=template&id=3c7f4020&"
import script from "./ModalVideo.vue?vue&type=script&lang=js&"
export * from "./ModalVideo.vue?vue&type=script&lang=js&"
import style0 from "./ModalVideo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports